// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__3-vPC","button":"profile_button__Ez5aV","link":"profile_link__1VrWr","card":"profile_card__8u7YB"};